import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LearnerJobSubscriptionVariables = Types.Exact<{
  input: Types.JobSubscriptionInput;
}>;


export type LearnerJobSubscription = { job: { id: string, status: Types.JobEntityStatusEnum } };


export const LearnerJobDocument = /*#__PURE__*/ gql`
    subscription learnerJob($input: JobSubscriptionInput!) {
  job(data: $input) {
    ... on JobType {
      id
      status
    }
  }
}
    `;

export function useLearnerJobSubscription<TData = LearnerJobSubscription>(options: Omit<Urql.UseSubscriptionArgs<LearnerJobSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<LearnerJobSubscription, TData>) {
  return Urql.useSubscription<LearnerJobSubscription, TData, LearnerJobSubscriptionVariables>({ query: LearnerJobDocument, ...options }, handler);
};